(function(){
    const $body = $("body");
    gsap.to('.photolist', 80,{
        yPercent: -50,
        ease: "none",
        repeat: -1
    });




    if ($(".counter")[0]) {
        // カウントダウンの目標日時: 2026年1月6日 午前10時
        const targetDate = new Date(2026, 0, 6, 10, 0, 0).getTime();

        // ページ読み込み時に既に目標日時を過ぎていたら非表示
        if (targetDate - new Date().getTime() < 0) {
            $('.counter,.pc-counter').hide();
        } else {
            const $dayEl = $('.js-day');
            const $hourEl = $('.js-hour');
            const $minuteEl = $('.js-minute');
            const $secondEl = $('.js-second');
            
            /**
             * 数値を2桁の文字列（ゼロパディング付き）に変換する
             */
            function formatTime(num) {
                return num.toString().padStart(2, '0');
            }

            function updateCountdown() {
                const now = new Date().getTime();
                const distance = targetDate - now;

                if (distance < 0) {
                    clearInterval(countdownInterval);
                    $dayEl.text('00');
                    $hourEl.text('00');
                    $minuteEl.text('00');
                    $secondEl.text('00');
                    return;
                }

                const second = 1000;
                const minute = second * 60;
                const hour = minute * 60;
                const day = hour * 24;
                const days = Math.floor(distance / day);
                const hours = Math.floor((distance % day) / hour);
                const minutes = Math.floor((distance % hour) / minute);
                const seconds = Math.floor((distance % minute) / second);
                
                $dayEl.text(formatTime(days));
                $hourEl.text(formatTime(hours));
                $minuteEl.text(formatTime(minutes));
                $secondEl.text(formatTime(seconds));
            }

            const countdownInterval = setInterval(updateCountdown, 1000);
            updateCountdown();
        }
    }





})();
